export { default } from './isImmutableSetSeq'
